const reportRoutes = [
	{
		path: '/report/quality',
		name: 'reportQuality',
		component: () => import('../quality/quality-report')
	},
	{
		path: '/report/quality/preview',
		name: 'reportQualityPreview',
		component: () => import('../quality/quality-report-preview')
	},
	{
		path: '/report/school',
		name: 'reportSchool',
		component: () => import('../school/index')
	},
	{
		path: '/report/school/preview',
		name: 'reportSchoolPreView',
		component: () => import('../school/preview')
	},
	{
		path: '/report/class/history',
		name: 'reportClassHistory',
		component: () => import('../class-history/index')
	},
	{
		path: '/report/student/history',
		name: 'reportStudentHistory',
		component: () => import('../student-history/index')
	},
	{
		path: '/report/knowledge',
		name: 'reportKnowledge',
		component: () => import('../knowledge/index')
	}
]
export default reportRoutes
